<div
  class="file-wrapper"
  [ngClass]="{'disabled': disabled, 'has-error': isIncorrectValue}"
>
  <div class="label">{{ label }}</div>
  <ng-content select="[file-content]"></ng-content>
</div>

@if (isIncorrectValue) {
  <yu-helper color="error" icon="warning-circle">{{ helperText }}</yu-helper>
}
